import React, { useState, useEffect } from "react";
import axios from "axios";
import {ReactComponent as Edit} from '../../assets/edit.svg';
import {ReactComponent as Delete} from '../../assets/dele.svg'
import {ReactComponent as SearchIcon } from "../../assets/serch-icon.svg";
import {ReactComponent as ClIcon} from '../../assets/close-icon.svg';
import {ReactComponent as SIcon} from '../../assets/save-icon.svg';
// import searchIcon from "../assets/serch-icon.svg";
import { ReactComponent as Plus} from "../../assets/p-icon.svg";
import Navbar from '../../components/Navbar';


const PaginationTable = () => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [showIcon, setShowIcon] = useState(true);
  const [ingredients, setIngredients] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [editFrom, setEditForm] = useState(false);
  const [nEIngredient, setNEIngredient] = useState("");
  const [cEIngredient, setCEIngredient] = useState("");
  const [sEIngredient, setSEIngredient] = useState("");
  const [newIName, setNewIName] = useState("");
  const [newICost, setNewICost] = useState("");
  const [newIStock, setNewIStock] = useState("");
  const [newIngred, setNewIngred] = useState("");
  const [editId, setEditId] = useState(0);
  const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
  const [uName, setUName] = useState("");
  const [uId , setUId] = useState("");
  const [userD, setUserD] = useState(null);
  useEffect(() => {
    const userDataString = sessionStorage.getItem('userData');
    if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserD(userData);
        // Use userData as needed
    }
}, []);
  useEffect(() => {
      const handleResize = () => {
          setSmallMedia(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    const userId = uId;
  useEffect(() => {
    fetchIngredients();
  }, [uId, userId]);
  useEffect(() => {
    setUId(userD?.id); 
    setUName(userD?.name);
}, [userD]);
  const fetchIngredients = async () => { 
    try {
      const response = await axios.get(`http://localhost:5000/ingredients?userId=${uId}`);
      setIngredients(response.data);
    //   console.log(response.data);
    //   console.log("This is from sm Ingredients");
      setTotalRows(response.data.length);
    } catch (error) {
      console.error('Error fetching ingredients:', error);
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setShowIcon(e.target.value === '');
  };

  const handleEditClick = (ingredient) => {
    setEditForm(true);
    setEditId(ingredient.id);
    setNEIngredient(ingredient.name);
    setCEIngredient(ingredient.cost_ml);
    setSEIngredient(ingredient.stock_level_ml);
  };

  const handleDeleteClick = (id) => {
    fetch(`http://localhost:5000/deleteIngredient/${id}`, {
      method: 'DELETE',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to delete ingredient');
      }
      fetchIngredients();

      alert('Ingredient deleted successfully');

      // Handle success
    })
    .catch(error => {
      console.error('Error deleting ingredient:', error.message);
      // Handle error
    });
  };
  
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, totalRows);
  const filteredIngredients = ingredients.filter((ingredient) =>
    ingredient.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const currentIngredients = filteredIngredients.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredIngredients.length / rowsPerPage);

  const pageButtons = [];
  for (let i = 1; i <= totalPages; i++) {
    pageButtons.push(
      <button
        key={i}
        onClick={() => setCurrentPage(i)}
        className={`pbtn ${currentPage === i && smallMedia ? "active12a2" : currentPage === i ? "active12" : ""}`}
      >
        {i}
      </button>
    );
  }
  const handleNameNew = (event) =>{
    setNewIName(event.target.value);
  }
  const handleCostNew = (event) =>{
  setNewICost(event.target.value);
  }
  const handleStockNew = (event) =>{
  setNewIStock(event.target.value);
  }
  const handleNameEdit = (event) =>{
    setNEIngredient(event.target.value);
  }
  const handleCostEdit = (event) =>{
    setCEIngredient(event.target.value);
  }
  const handleStockEdit = (event) =>{
  setSEIngredient(event.target.value);
  }
  const handleNewSave = () => {
    if (newIName.trim() === '' || newICost.trim() === '' || newIStock.trim() === '') {
      alert("All fields are required");
      return;
    }
  
    fetch(`http://localhost:5000/newIngredient`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: newIName,
        cost: newICost,
        stockLevel: newIStock,
        userId : uId
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to save new ingredient');
      }
      alert('New ingredient saved successfully');
      setNewIngred(false);
      fetchIngredients();
      // Handle success
    })
    .catch(error => {
      console.error('Error saving new ingredient:', error.message);
      // Handle error
    });
  };
  
  const handleCancelEdit = () => {
    setEditForm(false);
    setNewIngred(false);
  };
  const handleSaveChanges = () => {
    if(nEIngredient === '' || cEIngredient === '' || sEIngredient === ''){
      alert('All fields are required!');
      return;
    }else{
      fetch(`http://localhost:5000/updateIngredient/${editId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: nEIngredient,
          cost: cEIngredient,
          stockLevel: sEIngredient,
          userId: uId
        }),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to update ingredient');
        }
        alert('Ingredient updated successfully');
        fetchIngredients();
        setEditForm(false);
        // Handle success
      })
      .catch(error => {
        console.error('Error updating ingredient:', error.message);
        // Handle error
      });
    }

  };
  
  const handleNextClick = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousClick = () => {
    setCurrentPage(currentPage - 1);
  };
//   if(ingredients.lenght === 0){
//     fetchIngredients();
//   } 
  return (
    < div className="smallTable">
<Navbar />
    <div className="sp-recipes">
      <div className="recipe-left" style={{display: smallMedia ? "none" : "block"}} ></div>
      <div className="full-details">
      {/* First div */}
      <div className={`smtpDiv ${smallMedia ? "details2a" : "details2 topDiv "}`}>
      <div className={` same select-sp ${smallMedia ? "same2 display2 smallDrop" : ""}`}>
          Show
          <div className={`main-Select ${smallMedia ? "sub-class2 main-Select2" : ""}`}>
        <select value={rowsPerPage} onChange={handleRowsPerPageChange} className={`select-container ${smallMedia ? "select-container2" : ""}`}>
          {[5, 10, 15, 20, 25, 30].map((value) => (
            <option  className='options' key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        </div>
        Entries
          </div>
          <div className={` same ${smallMedia ? "same2 " : ""}`}>
            <div className={` same ${smallMedia ? "search-container2 smallSe" : "search-container"}`}>
              {/* <div className='triangle-container-sea'></div> */}
              <div
              className={`${smallMedia ? "shadeTriangle-sea2" : "shadeTriangle-sea"}`}
              ></div>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearch}
          className={` search-input ${smallMedia ? "search-input2 smSBox" : ""}`}
        />
      <span className={` ${smallMedia ? "search-icon2" : "search-icon"}`} style={{ display: showIcon ? "block" : "none"}}>
          <SearchIcon className="sp-icon" />
        </span>
      </div>
        </div>
        <div className={`adbntSm same btn-add ${smallMedia ? "same2" : ""}`}> 
            <button onClick={() => setNewIngred(true)} className='btnAdd smlbtn'>
            <div className={` ${smallMedia ? "shadeTriangle-adbnt2" : "shadeTriangle-adbnt"}`}></div>
              <div>
                <div className='icon smPIcon'>
                <Plus className="sp-icon"/>
                </div>
                <span className="add-text smBtn">Add New Ingredient</span>
              </div>
            </button>
          </div>
      </div>
      <div style={{display: editFrom ? "block" : "none"}}>
      <div className={`${smallMedia ? "popup2" : " popEI2 popup"}`} >
        <div className='triangle-container-pop'>
          <div className={`${smallMedia ? "shadeTriangle-pop" : " shadeTriangle-pop2"}`}></div>
          </div>
          {/* Popup content for Edit ingredient */}
          <div className="form-pump">
            <h2 className='headIngre'>Edit Ingredient</h2>
            <div className="inpt-cont">
              <label>Name:</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2"}`}>
              <div className="inptO"></div>
                <input
                  type="text"
                  value={nEIngredient}
                  onChange={handleNameEdit}
                  className="pop-inpt"
                />
                <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont">
              <label>Cost (ml):</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2"}`}>
              <div className="inptO"></div>
                <input
                  type="text"
                  value={cEIngredient}
                  onChange={handleCostEdit}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont">
              <label>Stock Level (ml):</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2"}`}>
              <div className="inptO"></div>
                <input
                  type="text"
                  value={sEIngredient}
                  onChange={handleStockEdit}
                  className="pop-inpt"
                />
              <div className="inptC"></div>

              </div>
            </div>
            <div className="pop-btn-sec">
            <div className={`${smallMedia ? "pop-btn" : " pop-btn2 btn266"}`}>
                <button onClick={handleCancelEdit} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="canIcon">
                <ClIcon className='sp-icon' />
              </div>
                  Close
                </button>
              </div>
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2"}`}>
                <button onClick={handleSaveChanges} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="svIcon">
                <SIcon className='sp-icon' />
              </div>
                <div>
                Save Change
                </div> 
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div className={`${smallMedia ? "popup2" : " popEI2 popup"}`} style={{display: newIngred ? "block" : "none"}}>
        <div className='triangle-container-pop'>
          <div className={`${smallMedia ? "shadeTriangle-pop" : " shadeTriangle-pop2"}`} ></div>
          </div>
          {/* Popup content for adding new ingredient */}
          <div className="form-pump">
            <h2 className='headIngre'>Add New Ingredient</h2>
            <div className="inpt-cont">
              <label>Name:</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2"}`}>
              <div className="inptO"></div>
                <input
                  type="text"
                  value={newIName}
                  onChange={handleNameNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont">
              <label>Cost (ml):</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={newICost}
                  onChange={handleCostNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont">
              <label>Stock Level (ml):</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  value={newIStock}
                  onChange={handleStockNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="pop-btn-sec">
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2 btn266"}`}>
                <button onClick={handleCancelEdit} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="canIcon">
                <ClIcon className='sp-icon' />
              </div>
              <div>
              Close
              </div>
                  
                </button>
              </div>
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2 "}`}>
                <button onClick={handleNewSave} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="svIcon-n">
                <SIcon className='sp-icon' />
              </div>
                <div>
                  Save
                </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      {/* Second div */}
      <div className="my-table smtbl1" >
        <table className="customTable"  style={{borderCollapse: "separate", borderSpacing: "0 0.9vw"}}>
          <thead className="tb-head borderRow">
            <tr className="my-row">
              <th className='na-sp-t'>
              <div className="flex-container">
              <div className='left-tr' style={{display : smallMedia ? 'none' : 'block'}}></div>
              <div className="sm-mr">
              Name
              </div>
              </div>
              </th>
              <th>Cost (ml)</th>
              <th>Stock Level (ml)</th>
              <th className='sp-td sp-tr spp'>
              <div className="flex-container sp-llst">
              <div>
              Action
              </div>
            <div className='right-tr summ' style={{display : smallMedia ? 'none' : 'block'}}></div>
              </div>
               </th>
            </tr>
          
          </thead>
          <tbody className="cu-body">
            {currentIngredients.map((ingredient) => (
              <tr key={ingredient.id} className="custom-row">
                <td className="first-td">{ingredient.name}</td>
                <td className="second-td">{ingredient.cost_ml}</td>
                <td className="third-td">{ingredient.stock_level_ml}</td>
                <td className="last-td rad2">
                <div className="flex-container">
                <button onClick={() => handleEditClick(ingredient)}
                className={`editconst  ${smallMedia ? "editconst2" : "ed-sp in-edbtn"}`}
                >
                    <div className={` ${smallMedia ? "shadeTriangle-idbnt2" : "shadeTriangle-idbnt"}`}></div>
                  <div className="inE-icon icon22" style={{display : smallMedia ? 'none' : 'block'}}>
                  <Edit className='sp-icon' />
                  </div>
                  <div>
                  Edit
                  </div>
                </button>
                <button onClick={() => handleDeleteClick(ingredient.id)}
                className={`deleteconst ${smallMedia ? "deleteconst2" : " in-debtn sp-margin"}`}
                >
                <div className={` ${smallMedia ? "shadeTriangle-idbntD2" : "shadeTriangle-idbntD"}`}></div>
                  <div className="inD-icon icon22" style={{display : smallMedia ? 'none' : 'block'}}>
                  <Delete className='sp-icon'/>
                  </div>
                  <div>
                  Delete
                  </div>
                </button>
                </div>
                
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Third div */}
      <div className='bothDiv' >
      <div className='bottomSh'>
          <div className='results'>
            Showing {startIndex + 1} to {endIndex}
          </div>
          <div className='whiteClass'>
            (Total {totalRows} entries)
          </div>
        </div>
          
      <div className="pagination-info">
      <button onClick={handlePreviousClick} className='constbtn' disabled={currentPage === 1}>Previous</button>
        {pageButtons}
        <button onClick={handleNextClick} className='constbtn' disabled={currentPage === totalPages}>Next</button>
      </div>
      </div>
      </div>
    <div className="recipe-right" style={{display: smallMedia ? "none" : "block"}}></div>
    </div>
  </div>
  );
};

export default PaginationTable;
